import { AnalyticsBrandSettings, AnalyticsEventData } from 'idt-analytics-api/models';
import { getDefaultAnalytics } from '../helpers/events.helper';
import { AnalyticsEcommerceHelpersOysho } from '../helpers/brand-analytics-ecommerce.helpers.oy';
import { AnalyticsHelpersOysho } from '../helpers/brand-analytics.helpers.oy';
import { AnalyticsGTMSettings, DefaultAnalyticsSettings } from 'analytics-api';
import { AnalyticsOyshoEventDataHelpers } from '../helpers/brand-analytics-event-data.helpers.oy';
import { AnalyticsOyshoEventsTransformer } from '../helpers/brand-analytics-events.transformer.oy';

export const ColbensonSearcherEvents: AnalyticsBrandSettings = {

  buscadorCatalogoAplicarFiltro(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const filter = `${componentData?.selectedFilter}`;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'buscador', 'aplicar_filtro', filter);
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['49', '78'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  buscadorCatalogoBuscar(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const searchTerm = `${componentData?.buttonText}`;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'buscador', 'buscar', searchTerm);
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['49', '178'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  buscadorCatalogoBusquedasPopulares(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const searchTerm = `${componentData?.buttonText}`;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'buscador', 'busquedas_populares', searchTerm);
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['49', '178'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  buscadorCatalogoCeroResultados(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const searchTerm = `${componentData?.buttonText}`;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'buscador', 'cero_resultados', searchTerm);
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['49'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  buscadorCatalogoLimpiarFiltro(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const filter = `${componentData?.selectedFilter}`;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'buscador', 'limpiar_filtro', filter);
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  buscadorCatalogoUltimasBusquedas(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const searchTerm = `${componentData?.buttonText}`;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'buscador', 'ultimas_busquedas', searchTerm);
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['49', '178'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  buscadorCatalogoVerEventos(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const url = `${componentData?.url}`;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'buscador', 'ver_eventos', url);
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  buscadorCatalogoVerProducto(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const partnumber = componentData.partnumber;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'buscador', 'ver_producto', partnumber);
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['15', '20', '46', '47', '99', '100', '101', '117'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    if (componentData?.products?.length) {
      settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceClick(componentData, context);
    }
    return settingsGTM;
  },

  buscadorCatalogoVerProductoCross(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const partnumber = componentData.partnumber;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'buscador', 'ver_producto_cross', partnumber);
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['20', '46', '47', '70', '98', '99', '100', '101', '117', '139', '178'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    if (componentData?.products?.length) {
      settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceClick(componentData, context);
    }
    return settingsGTM;
  },

  buscadorCatalogoVerRecomendacion(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'buscador', 'ver_recomendacion');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  buscadorCatalogoSeleccionarColor(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = `${AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: false })}-color_${product?.color}`;
    }
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'buscador', 'seleccionar_color', partnumber);
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['20', '48'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  buscadorCatalogoSeleccionarTalla(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = `${AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: false })}-talla_${product?.sizeCode}`;
    }
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'buscador', 'seleccionar_talla', partnumber);
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['20', '58'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  /* TODO: Emitir evento cuando se añada venta */
  buscadorCheckoutAnadirProductoCesta(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: false });
    }
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'checkout', 'buscador', 'anadir_producto_cesta', partnumber
    );
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['16', '17', '20', '48', '58', '70', '71', '98', '198'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceClick(componentData, context);
    return settingsGTM;
  },

  buscadorCatalogoVerMas(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const searchTerm = `${componentData?.buttonText}`;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'buscador', 'ver_mas', searchTerm);
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  /* TODO: Emitir evento cuando se añada venta */
  buscadorWishlistAnadirProductoWishlist(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: false });
    }
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'wishlist', 'buscador', 'anadir_producto_wishlist', partnumber
    );
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['16', '17', '20', '71', '198'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },
};
